/**
 * Moderation Active Moderators Panel
 *
 * Displays the number of active moderators
 */

import { Card, Shimmer, Text } from '@soteria/design-system-ve';

import * as styles from './ModerationStatsPanel.css';

interface ModerationActiveModeratorsPanelProps {
  activeModerators: number;
  isLoading?: boolean;
}

export function ModerationActiveModeratorsPanel({ activeModerators, isLoading = false }: ModerationActiveModeratorsPanelProps) {
  if (isLoading) {
    return (
      <Card elevation="low" padding="medium">
        <div className={styles.panelContent}>
          <div className={styles.header}>
            <span className={styles.title}>ACTIVE MODERATORS</span>
          </div>
          <Shimmer className={styles.shimmerValue} label="Loading active moderators count" />
        </div>
      </Card>
    );
  }

  return (
    <Card elevation="low" padding="medium">
      <div className={styles.panelContent}>
        <div className={styles.header}>
          <span className={styles.title}>ACTIVE MODERATORS</span>
        </div>
        <Text as="div" className={styles.value}>
          {activeModerators}
        </Text>
        <Text as="div" className={styles.subtitle}>
          Currently online
        </Text>
      </div>
    </Card>
  );
}
